module.exports = __webpack_public_path__ + "assets/media/b2aa02f.b2aa02f0.mp4";